import { dictionariesApi, DictionaryApi } from "api/dictionaries/dictionariesApi";
import { IDropdownOption } from "components/atoms";
import { useEffect, useState } from "react";

export const useDictionary = (dictionaryId: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<DictionaryApi | null>(null);

  useEffect(() => {
    const fetchDictionary = async () => {
      const res = await dictionariesApi.fetchById(dictionaryId);
      try {
        setData(res.data);
      } catch (error) {
        // Handle error appropriately, perhaps with another state variable
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchDictionary();
  }, [dictionaryId]);

  return { loading, data };
};

export const useDictionaryValuesOptions = (dictionaryId: number) => {
  const { loading, data } = useDictionary(dictionaryId);
  return {
    loading,
    options:
      data?.values.map((v) => ({
        value: v.id,
        label: v.value,
      })) ?? ([] as IDropdownOption[]),
  };
};
